module.exports = __webpack_public_path__ + "images/emoji/large_blue_circle.bee365c88b701f9e7648.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/large_blue_circle.png
// module id = dfqE
// module chunks = 13